import { BooleanBitString } from '../competitions/types'
import { CONSTS } from '../config/const'

export const filterObjectByKey = <T extends object>(
    obj: T,
    callback: (key: string) => boolean,
): Partial<T> => {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => callback(key))) as Partial<T>
}

export const isObjectShallowEqual = <Object1 extends object, Object2 extends object>(
    object1: Object1 | undefined | null,
    object2: Object2 | undefined | null,
): boolean => {
    if (object1 === object2) return true
    if (!object1 || !object2) return false

    const keys1 = Object.keys(object1)
    const keys2 = Object.keys(object2)
    if (keys1.length !== keys2.length) {
        return false
    }
    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false
        }
    }
    return true
}

// If you modify the regular expression in this function, make sure to replicate the same modifications in the equivalent PHP function (Plugin competition)
// If the modifications are not replicated, you may encounter 404 errors on the competition page (due to the protection mechanism)
export const slugify = (input: string) => {
    return input
        .trim()
        .toLowerCase()
        .replace(/[àáâãäå]/g, 'a')
        .replace(/[ç]/g, 'c')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/[ñ]/g, 'n')
        .replace(/[òóôõöø]/g, 'o')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ýÿ]/g, 'y')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)+/g, '')
        .replace(/-+/g, '-')
}

export const getBodyDataAttribute = (attributeName: string, defaultValue: string = '') => {
    const attribute = document.body.getAttribute(attributeName)
    return attribute ?? defaultValue
}

export const isInternal = (url: string) =>
    new URL(url, window.location.origin).hostname === window.location.hostname

export const xorDecipherBase64 = (strBase64, key) => {
    const str = window.atob(strBase64)
    let result = ''
    let key_len = key.length
    for (let i = 0; i < str.length; i++) {
        result += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key_len))
    }
    return result
}

export const xorDecipherAndParse = (str: string) => {
    const decodeKey = getBodyDataAttribute(CONSTS.COMPETITION_CFK_ATTRIBUTES_NAME, 'nokey')
    const decodedStringifyAttributes = xorDecipherBase64(str, decodeKey)
    return JSON.parse(decodedStringifyAttributes)
}

export const flagUrl = (countryName: string) => {
    return `${CONSTS.FLAGS_FOLDER}/${countryName.toLowerCase()}.svg`
}

export const booleanBitStringToBoolean = (binaryString: BooleanBitString): boolean => {
    const trueBinaryString = '1'
    return binaryString === trueBinaryString
}
